import React from 'react';
import PropTypes from 'prop-types';
import { coal, slate } from '../colors';

var Tab = function Tab(_ref) {
  var id = _ref.id,
      title = _ref.title,
      description = _ref.description,
      Icon = _ref.icon,
      onTabClick = _ref.onTabClick,
      isActive = _ref.isActive;
  return React.createElement("div", {
    "data-testid": id,
    className: "tab ".concat(isActive ? 'tab-active' : ''),
    onClick: function onClick(event) {
      return onTabClick(event, id);
    }
  }, Icon ? React.createElement(Icon, {
    "data-testid": "icon-for-".concat(id),
    weight: "light",
    color: isActive ? coal : slate,
    size: "2x"
  }) : null, React.createElement("div", null, React.createElement("h5", {
    className: "tab-title ".concat(isActive ? 'tab-title-active' : '')
  }, title), description ? React.createElement("p", null, description) : null));
};

Tab.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  icon: PropTypes.func,
  onTabClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool
};
export default Tab;